const SYMBOLS = {
  INR: "₹",
  USD: "$",
  AED: "د.إ",
  EUR: "€",
  GBP: "£",
};

const LOCALES = {
  INR: "en-IN",
  USD: "en-US",
  AED: "en-AE",
  EUR: "en-IE",
  GBP: "en-GB",
};

export function currencyCode(code) {
  if (typeof code !== "string") return "INR";
  const normalized = code.trim().toUpperCase();
  return /^[A-Z]{3}$/.test(normalized) ? normalized : "INR";
}

export function currencySymbol(code) {
  const normalized = currencyCode(code);
  return SYMBOLS[normalized] || normalized;
}

/** Major-unit price (already in rupees, dirhams, or dollars). */
export function formatPrice(amount, code) {
  const normalized = currencyCode(code);
  const value = Number(amount);
  if (!Number.isFinite(value)) return "-";
  const text = Math.round(value).toLocaleString(LOCALES[normalized] || "en");
  return `${currencySymbol(normalized)}${text}`;
}
